<template>
  <div class="professional">
    <span class="professional__text"> {{ translate('rdProfessionalRateApplied') }}</span>
    <i :id="labelId" v-if="professionalRateLabel" class="icon-info-b2b"></i>
    <b-popover :target="labelId" triggers="hover focus" placement="top" content="Popover content">
      <div class="tooltip-box">
        <p class="tooltip-box-description">{{ professionalRateLabel }}</p>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
export default {
  components: {
    BPopover
  },
  name: 'ProfessionalLabel',
  props: {
    professionalRateLabel: String
  },
  data: () => ({
    labelId: null
  }),
  created() {
    this.labelId = String(this._uid)
  }
}
</script>

<style scoped lang="scss">
.professional {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  max-height: min-content;
  margin-bottom: 0.9rem;
  i {
    width: 100%;
    height: 100%;
    font-size: 2rem;
    margin-left: 0.9rem;
  }
  span {
    font-size: 1.2rem;
  }

  &__text {
    padding: 0.2rem 1.1rem;
    font-weight: 600;
    font-size: 1.4rem;
    color: #50b065;
    white-space: nowrap;
  }
}

.tooltip-box {
  background-color: #fff;
  padding: 1rem;
  font-size: 1.2rem;
  &-description {
    margin: 0;
  }
}
.popover {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  top: -4px !important;
}
</style>
